import React from 'react';
import '../styles/OverlayContainer.css';

const OverlayContainer = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null; // Don't render if not open

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div
        className="overlay-container"
        onClick={(e) => e.stopPropagation()} // Prevent click propagation
      >
        <button className="overlay-close" onClick={onClose}>
          &times;
        </button>
        <div className="overlay-content">{children}</div>
      </div>
    </div>
  );
};

export default OverlayContainer;